import { C } from "../../styles/theme";

export default function SecHdr({ tag, title, sub, light }) {
  return (
    <div style={{ textAlign: "center", marginBottom: 48 }}>
      {tag && (
        <div style={{ display: "inline-flex", alignItems: "center", gap: 7, background: light ? "rgba(232,89,60,.1)" : "rgba(232,89,60,.08)", border: light ? "1px solid rgba(232,89,60,.3)" : "1px solid rgba(232,89,60,.2)", borderRadius: 24, padding: "6px 16px", marginBottom: 16 }}>
          <span style={{ color: light ? "#F2A623" : "#E8593C", fontSize: 11, fontWeight: 700, letterSpacing: 1.1, textTransform: "uppercase" }}>{tag}</span>
        </div>
      )}
      <h2 className="serif" style={{ fontSize: 32, fontWeight: 900, color: light ? "#fff" : C.blue, margin: "0 0 12px", lineHeight: 1.15, letterSpacing: "-0.3px" }}>{title}</h2>
      {sub && <p style={{ fontSize: 15.5, color: light ? "rgba(255,255,255,.65)" : "#6A7A8A", maxWidth: 560, margin: "0 auto", lineHeight: 1.8 }}>{sub}</p>}
    </div>
  );
}
